module.exports = __webpack_public_path__ + "static/media/library.75bd3d21.svg";